const o = {
  tooltip: 100,
  popover: 200,
  droplist: 300,
  overlay: 1e3,
  sidepanel: 2e3,
  modal: 3e3,
  notification: 2e4,
  debug: 999999999999999
};
export {
  o as zindex
};
